import { CoordinatesModel } from '../../models/coordinates.model';

export class CoordinatesHelper {

    /**
     * Gets the coordinates of the provided element
    */
    static getElementCoordinates(element: HTMLElement): CoordinatesModel {
        // Position of the element within the viewport
        const positionInViewport: any = element.getBoundingClientRect();

        // Viewport scroll position
        const viewportScrollLeft: number = window.pageXOffset || document.documentElement.scrollLeft;
        const viewportScrollTop: number = window.pageYOffset || document.documentElement.scrollTop;

        // Element dimensions
        const height: number = element.offsetHeight;
        const width: number = element.offsetWidth;

        // Simple positional element coordinates
        const top: number = positionInViewport.top + viewportScrollTop;
        const left: number = positionInViewport.left + viewportScrollLeft;

        // Element coordinates derived from simple
        // positional coordinates and dimensions
        const right: number = left + width;
        const bottom: number =  top + height;

        // Resulting coordinates
        const elementCoordinates: CoordinatesModel = new CoordinatesModel(height, width, top, right, bottom, left);

        return elementCoordinates;
    }

    /**
     * Gets the coordinates of the window
    */
    static getWindowCoordinates() {
        // Window dimensions
        const height: number = window.innerHeight;
        const width: number = window.innerWidth;

        // Simple positional window coordinates
        const top: number = window.scrollY;
        const left: number = window.scrollX;

        // Window coordinates derived from simple
        // positional coordinates and dimensions
        const right: number = left + width;
        const bottom: number =  top + height;

        // Resulting coordinates
        const windowCoordinates: CoordinatesModel = new CoordinatesModel(height, width, top, right, bottom, left);

        return windowCoordinates;
    }

}
